(function(angular){
    'use strict';

    angular.module('nucleus.widgets').factory('nucleusWidgetsManager', widgetsManager);
    widgetsManager.$inject = ['$q'];

    function widgetsManager($q){
        var factory = {
            loadFirmWidgetRows: loadFirmWidgetRows,
            loadClientWidgetRows: loadClientWidgetRows
        };

        var fakeFirmWidgets = [
           { title: 'DRIVE Stats', type: 'driveUsage', sizeX: 1, sizeY: 1, row: 0, col: 0 }
        ];

        var fakeClientWidgets = [
           { title: 'Point-Of-Contact Information', type: 'clientInfo', sizeX: 2, sizeY: 1, row: 0, col: 0 }
        ];

        return factory;

        //////////

        function loadFirmWidgetRows(){
            return loadWidgetRows('firm');
        }

        function loadClientWidgetRows(client){
            return loadWidgetRows('client', client);
        }

        //////////

        function loadWidgetRows(widgetType, data){
            return load(widgetType).then(function(widgetData){
                // TODO: FOR NOW DIVIDE WIDGETS INTO EQUAL ROWS
                var rows = [];
                var currentRow = [];
                var widget;
                var columnCount = 0;

                for(var index = 0; index < widgetData.length; index++){
                    widget = widgetData[index];
                    widget.data = data;

                    // Does this widget fit in this row?
                    if(currentRow.length + widget.sizeX > 3){
                        rows.push(currentRow);
                        currentRow = [];
                        currentRow.push(widget);
                        columnCount = widget.sizeX;

                        // Last widget?
                        if(index === widgetData.length - 1){
                            rows.push(currentRow);
                        }

                        continue;
                    }

                    currentRow.push(widget);
                    columnCount+= widget.sizeX;

                    // Last widget or last widget for this row?
                    if(index === widgetData.length - 1 || columnCount % 3 === 0){
                        rows.push(currentRow);
                        currentRow = [];
                        columnCount = 0;
                    }
                }

                return rows;
            });
        }

        function load(widgetType){
            // TODO: GET REAL WIDGET DATA FOR USER
            var deferred = $q.defer();

            deferred.resolve(widgetType === 'client' ? fakeClientWidgets : fakeFirmWidgets);

            return deferred.promise;
        }
    }
})(window.angular);
